import { useState } from 'react';
import { Share2 } from 'lucide-react';
import { ShareModal } from './ShareModal';
import { buildShareUrl, buildShareText } from '../hooks/useShare';

interface ShareButtonProps {
  /** Path to share (will be combined with window.location.origin) */
  path: string;
  /** Title for the share (movie title, profile name, etc.) */
  title: string;
  /** Optional custom share text (defaults to "{title} — Filmple") */
  text?: string;
  /** Optional preview image URL (poster, avatar, etc.) */
  image?: string;
  /** Button variant */
  variant?: 'default' | 'icon-only';
  /** Additional class names */
  className?: string;
}

export function ShareButton({
  path,
  title,
  text,
  image,
  variant = 'default',
  className = '',
}: ShareButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const url = buildShareUrl(path);
  const shareText = text ?? buildShareText(title);

  if (variant === 'icon-only') {
    return (
      <>
        <button
          onClick={() => setIsModalOpen(true)}
          className={`flex items-center justify-center h-10 w-10 rounded-lg ring-1 ring-white/[0.08] text-slate-400 hover:ring-white/[0.12] hover:text-white transition-colors ${className}`}
          title="Share"
        >
          <Share2 size={18} />
        </button>

        <ShareModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          url={url}
          title={title}
          text={shareText}
          image={image}
        />
      </>
    );
  }

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className={`flex items-center gap-2 h-10 px-4 rounded-lg font-medium ring-1 ring-white/[0.08] text-slate-300 hover:ring-white/[0.12] hover:text-white transition-all ${className}`}
      >
        <Share2 size={18} />
        Share
      </button>

      <ShareModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        url={url}
        title={title}
        text={shareText}
        image={image}
      />
    </>
  );
}
